/*global angular*/

import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import moment from 'moment';
import { isArray } from 'lodash';
import { exportTable } from './exportTable';
import { generateReport } from './certificate_report';
import './style.less';

export default function($log, $q, $filter, $stateParams, $location, $anchorScroll, ApiClass, RegulatorClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;
  vm.timeStamp = `?time=${new Date().getTime()}`;

  const profile_uid = $stateParams.employeeID || $stateParams.id;

  vm.anchorScroll = index => {
    const newHash = 'report-anchor-' + index;
    if ($location.hash() !== newHash) return $location.hash('report-anchor-' + index);
    $anchorScroll();
  };

  vm.all = () => {
    vm.regulatorCerts = [
      {
        title: 'All Certificates',
        regulatorIds: [],
        certs: vm.certs
      }
    ];
    vm.regulator = false;
    vm.regulatorIds = [];
    vm.setCustomFilters();
  };

  vm.setCerts = tiles => {
    vm.regulatorCerts = [];
    tiles.forEach(tile => {
      const {
        hoursActual,
        text,
        subText,
        certs,
        regulatorIds,
        hoursCompleted,
        hoursNeeded = 0,
        hoursIncomplete,
        category
      } = tile;
      vm.regulatorCerts.push({
        title: text,
        name: text,
        subText,
        category,
        hoursActual,
        hoursCompleted,
        hoursNeeded,
        hoursIncomplete,
        regulatorIds,
        certs: vm.certs.filter(({ cert_id }) => certs.includes(cert_id))
      });
    });
    vm.setCustomFilters();
  };

  vm.setCustomFilters = () => {
    vm.filteredCerts = vm.regulatorCerts.map(segment => {
      if ((!vm.startDate && !vm.endDate) || segment.title !== 'All Certificates') {
        return (segment.filteredCerts = angular.copy(segment.certs));
      }

      const startSeconds = new Date(vm.startDate).getTime();
      const endSeconds = new Date(vm.endDate).getTime();

      setReportParams();

      segment.filteredCerts = segment.certs.filter(({ date }) => {
        const currentSeconds = new Date(date).getTime();

        if ((vm.startDate && currentSeconds < startSeconds) || (vm.endDate && currentSeconds > endSeconds)) {
          return false;
        }

        return true;
      });

      return segment.filteredCerts;
    });
  };

  vm.notAppliedTable = [
    { text: 'Admin Approval', key: 'adminApproval', description: 'Certificate was approved by admin.' },
    { text: 'Credit', key: 'credit', description: 'Total credit amount is less than min required.' },
    { text: 'Date', key: 'date', description: 'Certificate falls between cycle start and end dates.' },
    { text: 'Industry', key: 'industry', description: 'Subject Area is from wrong industry.' },
    { text: 'Sponsor', key: 'sponsor', description: 'Certificate sponsors.' }
  ];

  function setReportParams() {
    vm.reportParams = {
      profile_uids: [profile_uid],
      rangeEnd: vm.endDate,
      rangeStart: vm.startDate
    };
  }

  vm.exportTable = (regulatorIds, filteredCerts) => exportTable($filter, regulatorIds, filteredCerts);
  vm.generateReport = (regulatorIds, filteredCerts) =>
    generateReport($filter, vm.regulatorDict, regulatorIds, filteredCerts);

  vm.downloadPDFs = (regulatorName = 'AllCerts', filteredCerts) => {
    const zipName = `${regulatorName}.zip`;
    const zip = new JSZip();
    const promises = filteredCerts.filter(({ pdf_uploaded }) => pdf_uploaded).map(({ pdf, cert, cert_id }) => {
      return new Promise(resolve => {
        JSZipUtils.getBinaryContent(pdf + vm.timeStamp, (error, data) => {
          if (error) resolve();
          const uid = $filter('uppercase')($filter('limitTo')(cert_id, 8));
          const fileName = `${cert}-${uid}.pdf`;
          zip.file(fileName, data, { binary: true });
          resolve();
        });
      });
    });

    $q.all(promises)
      .then(() =>
        zip.generateAsync({
          type: 'blob'
        })
      )
      .then(content => {
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(content);
        downloadLink.download = zipName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.recalc = () => {
    vm.recalcBtn = true;
    ApiClass.usersIdTypeGet(
      { id: profile_uid, type: 'licenses', manage: false },
      {},
      {
        queryParams: {
          data_type: 'update'
        }
      }
    )
      .then(() => {
        vm.recalcBtn = false;
        activate();
      })
      .catch(error => {
        vm.recalcBtn = false;
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    $log.log('Users Report view activated');
    vm.loaded = false;

    vm.profileUid = profile_uid;
    vm.regulatorDict = {};

    const qArr = [
      ApiClass.usersIdGet(
        { id: profile_uid, manage: false },
        {},
        {
          queryParams: {
            'include:certificatescomp': true
          }
        }
      ),
      ApiClass.usersIdTypeGet(
        { id: profile_uid, type: 'licenses', manage: false },
        {},
        {
          queryParams: {
            data_type: 'report'
          }
        }
      ),
      RegulatorClass.loadRegulators()
    ];

    $q.all(qArr)
      .then(([{ data: { item: profile, certificates } }, { data: { items: regs } }, { objCurrent }]) => {
        vm.regulatorDict = objCurrent;
        certificates = isArray(certificates) ? certificates : [];
        certificates.forEach(cert => {
          if (!cert.carry_over) return;
          cert.date = new Date(0).toISOString();
        });

        vm.profile = profile;
        regs = regs.map(reg => {
          const { date, name } = reg;
          const tempYear = moment(date).year();
          reg.tile_name = `${name} ${tempYear}`;

          return reg;
        });

        vm.regs = regs.sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name == b.name && moment(a.date).year() > moment(b.date).year()) return -1;
          return 1;
        });

        vm.certs = certificates.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

        vm.certificatesAppliedDict = certificates.reduce((obj, cert) => {
          const { cert: name, cert_id, date } = cert;

          if (!obj[cert.cert_id]) {
            obj[cert.cert_id] = {
              cert: name,
              cert_id,
              date
            };
          }

          if (!cert.hours_applied || !Object.keys(cert.hours_applied).length) return obj;

          Object.keys(cert.hours_applied).forEach(lic_yr => {
            const reg_id = lic_yr.slice(0, -5);

            Object.keys(cert.hours_applied[lic_yr]).forEach(category => {
              obj[cert.cert_id][`${reg_id}_${category}`] = cert.hours_applied[lic_yr][category];
            });
          });

          return obj;
        }, {});

        setReportParams();

        vm.all();
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/report/controller.js